<template>
<div v-if="isShow" id="notes" class="notes" :style="{ 'background-image': 'url('+ bg +')' }">
  <div id="js-show-contents" class="ml16 mr16">
    <router-link :to="{ name: 'NotesDoNotGiveUp', params: {} }" class="giveup_btn">
      <img :src="require('@/assets/images/fanclub/notes/do_not_give_up.svg')" alt="">
    </router-link>
    <div class="card">
      <div class="card_date">
        <div class="year rb">{{ year }}</div>
        <div class="month rb">{{ month }}</div>
      </div>
      <div class="card_contents">
        <ul class="card_list">
          <!-- Fellow Training -->
          <li v-for="val, index in fellowTrainingNote.note.chapterList" :key="val + index" class="card_item">
            <button @click="changeAudio(val.seqNo)" class="card_btn rr">{{ val.chapterTitle }}</button>
          </li>
          <!-- 世界の格言 -->
          <li v-for="val, index in worldAdageNote.note.chapterList" :key="val + index" class="card_item">
            <button class="card_btn rr">{{ val.chapterTitle }}</button>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div id="js-note-audio" class="note_audio">
    <div id="js-audio-contents" class="note_contents">
      <AudioTitle
        :title="getTitle()"
      />
      <AudioPlayer
        ref="AudioPlayer"
        @changeChapter="changeChapter"
        @endChapter="endChapter"
      />

    </div>
    <AudioChapter
      :isChapter="true"
      :chapterList="getChapter()"
      :nowSeqNo="nowSeqNo"
      @changeChapter="changeAudio"
    />
  </div>


</div>
<div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import Config from '@/config/config';
import Check from '@/model/getToken';
import Height from '@/model/notes/height';
import NoteApi from '@/components/api/fanClub/notes';
import AudioPlayer from  '@/components/fanClub/notes/AudioPlayer';
import AudioTitle from  '@/components/fanClub/notes/AudioTitle';
import AudioChapter from  '@/components/fanClub/notes/AudioChapter';

const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const today = new Date();

export default {
  components: {
    AudioTitle,
    AudioPlayer,
    AudioChapter,
  },
  data() {
    return {
      isShow: true,
      bg: require('@/assets/images/fanclub/notes/bg.png'),
      year: today.getFullYear(),
      month: months[today.getMonth()],

      isSelecetNote: '',
      nowSeqNo: 0,

      everyDayNote: {
        enabled: false,
        existsNew: false,
        note: {
          title: '',
          startSeqNo: 1,
          existsNew: false,
          chapterList: [],
        }
      },
      fellowTrainingNote: {
        enabled: false,
        existsNew: false,
        note: {
          title: '',
          startSeqNo: 1,
          existsNew: false,
          chapterList: [],
        }
      },
      worldAdageNote: {
        enaenabledbled: false,
        existsNew: false,
        note: {
          title: '',
          startSeqNo: 1,
          existsNew: false,
          chapterList: [],
        }
      },
    }
  },
  methods: {
    getTitle() {
      if(this.isSelecetNote == 'fellowTrainingNote') {
        return this.fellowTrainingNote.note.title
      }
      if(this.isSelecetNote == 'everyDayNote') {
        return this.everyDayNote.note.title;
      }
      if(this.isSelecetNote == 'worldAdageNote') {
        return this.worldAdageNote.note.title;
      }
    },
    getChapter() {
      if(this.isSelecetNote == 'fellowTrainingNote') {
        return this.fellowTrainingNote.note.chapterList
      }
      if(this.isSelecetNote == 'everyDayNote') {
        return this.everyDayNote.note.chapterList;
      }
      if(this.isSelecetNote == 'worldAdageNote') {
        return this.worldAdageNote.note.chapterList;
      }
    },
    changeChapter(data) {
      if(data == 'prev') {
        if(this.nowSeqNo > 1) {
          this.nowSeqNo = this.nowSeqNo - 1;
        } else {
          // TODO: 一番最後のオーディオを選択する
        }
      }
      if(data == 'next') {
        let nowChapter = this.getChapter();
        let index = nowChapter.findIndex(val => val.seqNo == this.nowSeqNo);
        this.nowSeqNo = nowChapter[index].nextSeqNo;
        // this.nowSeqNo = this.nowSeqNo + 1;
      }
      this.setAudio();
    },
    setAudio() {
      let nowChapter = this.getChapter();
      let index = nowChapter.findIndex(val => val.seqNo == this.nowSeqNo);
      this.$refs.AudioPlayer.setAudio(nowChapter[index].audioPath);
    },
    changeAudio(seqNo) {
      this.nowSeqNo = seqNo;
      this.setAudio();
      // this.$refs.AudioPlayer.toggleAudio();
      this.$refs.AudioPlayer.playAudioFromNotes();
    },
    endChapter() {
      let nowChapter = this.getChapter();
      let index = nowChapter.findIndex(val => val.seqNo == this.nowSeqNo);
      this.nowSeqNo = nowChapter[index].nextSeqNo;
      this.setAudio();
    },
    setData(data) {
      this.everyDayNote.enabled = data.everyDayNote.enabled;
      this.everyDayNote.existsNew = data.everyDayNote.existsNew;
      this.everyDayNote.note.title = data.everyDayNote.note.title;
      this.everyDayNote.note.startSeqNo = data.everyDayNote.note.startSeqNo;
      this.everyDayNote.note.existsNew = data.everyDayNote.note.existsNew;
      this.everyDayNote.note.chapterList.push(...data.everyDayNote.note.chapterList);

      this.fellowTrainingNote.enabled = data.fellowTrainingNote.enabled;
      this.fellowTrainingNote.existsNew = data.fellowTrainingNote.existsNew;
      this.fellowTrainingNote.note.title = data.fellowTrainingNote.note.title;
      this.fellowTrainingNote.note.startSeqNo = data.fellowTrainingNote.note.startSeqNo;
      this.fellowTrainingNote.note.existsNew = data.fellowTrainingNote.note.existsNew;
      this.fellowTrainingNote.note.chapterList.push(...data.fellowTrainingNote.note.chapterList);

      this.worldAdageNote.enabled = data.worldAdageNote.enabled;
      this.worldAdageNote.existsNew = data.worldAdageNote.existsNew;

      if(data.worldAdageNote.note != null) {
        this.worldAdageNote.note.title = data.worldAdageNote.note.title;
        this.worldAdageNote.note.startSeqNo = data.worldAdageNote.note.startSeqNo;
        this.worldAdageNote.note.existsNew = data.worldAdageNote.note.existsNew;
        this.worldAdageNote.note.chapterList.push(...data.worldAdageNote.note.chapterList);
      }

      this.nowSeqNo = this.fellowTrainingNote.note.startSeqNo;

    },
    initialized() {
      this.isSelecetNote = 'fellowTrainingNote';

      this.everyDayNote.enabled = false;
      this.everyDayNote.existsNew = false;
      this.everyDayNote.note.title = '';
      this.everyDayNote.note.startSeqNo = 1;
      this.everyDayNote.note.existsNew = false;
      this.everyDayNote.note.chapterList.splice(0, this.everyDayNote.note.chapterList.length);

      this.fellowTrainingNote.enabled = false;
      this.fellowTrainingNote.existsNew = false;
      this.fellowTrainingNote.note.title = '';
      this.fellowTrainingNote.note.startSeqNo = 1;
      this.fellowTrainingNote.note.existsNew = false;
      this.fellowTrainingNote.note.chapterList.splice(0, this.fellowTrainingNote.note.chapterList.length);

      this.worldAdageNote.enabled = false;
      this.worldAdageNote.existsNew = false;
      this.worldAdageNote.note.title = '';
      this.worldAdageNote.note.startSeqNo = 1;
      this.worldAdageNote.note.existsNew = false;
      this.worldAdageNote.note.chapterList.splice(0, this.worldAdageNote.note.chapterList.length);
    },
    async apiGetNote() {
      await NoteApi.getNote().then((val) => {
        console.log('音声データ');
        console.log(val);
        this.setData(val);
        this.setAudio();
      });
    },
    setSeqNoIndex() {
      return this.setAudio().note.chapterList.findIndex(val => val.seqNo == this.nowSeqNo);
    },
  },

  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.initialized(); // 初期化
      await this.apiGetNote(); // データ取得
      Height.initializedScroll();
    } else {
      this.isShow = false;
    }
  },
}
</script>

<style lang="css" scoped>
/* 背景画像を画面いっぱいにするために使用 */
.notes {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  /* overflow: hidden; */
  /* padding-bottom: 200px; */
}
.notes .notes_wrap {
  transition: transform .3s;
}
.notes {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top 0 center;
}
.giveup_btn {
  display: block;
  margin-left: auto;
  width: 60px;
}

.card {
  -ms-align-items: center;
  align-items: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%), rgba(41, 41, 41, 0.7);
  backdrop-filter: blur(4px);
  border-radius: 6px;
  display: flex;
  margin-top: 10px;
  padding: 4px 18px;
}

.card_date {
  color: #fff;
  margin-right: 30px;
  text-align: center;
  width: 20.6%;
}

.year {
  font-size: 14px;
}

.month {
  font-size: 17px;
}

.card_contents {
  position: relative;
  padding-left: 16px;
  width: 79.4%;
}

.card_contents::before {
  background: linear-gradient(360deg, rgba(217, 217, 217, 0) 2.27%, #D9D9D9 48.05%, rgba(217, 217, 217, 0) 93.83%);
  bottom: 0;
  content: '';
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 1px;
}

.card_list {
  padding: 10px 0;
}

.card_item {
  margin-top: 3px;
}

.card_btn {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 12px;
  padding: 0;
}

.note_audio {
  background: rgba(0, 89, 163, 0.3);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(27.18px);
  left: 0;
  margin-top: 16px;
  padding: 0 24px 56px;
  position: fixed;
  transition: transform .3s;
  transform: translateY(0);
  width: 100%;
  z-index: 10;
  /* top: 477px; */
}

.note_contents {
  padding: 16px 0 25px;
  /* padding-bottom: 25px; */
}



</style>



// WEBPACK FOOTER //
// src/views/fanClub/notes/Notes.vue